
// settings
const debugGTMevents = true;

export const gtmEventsInit = () => {

	// console.log('gtmEventsInit')
	
	//nous-contacter-header
	$("header #principal-navbar ul.nav.navbar-nav.navbar-right > li:nth-last-child(2) a").off('click');
	$("header #principal-navbar ul.nav.navbar-nav.navbar-right > li:nth-last-child(2) a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic Nous contacter - Toutes pages | clicID = nous-contacter-header") : '';
		dataLayer.push({
			'event': 'Clic Nous contacter - Toutes pages',
			'clicID': 'nous-contacter-header'
		});
	});


	//Clic numero telephone header
	$(".customers-care a.phone").off('click');
	$(".customers-care a.phone").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic numero telephone header | clicID = telephone header") : '';
		dataLayer.push({
			'event': 'Clic numero telephone header',
			'clicID': 'telephone header'
		});
	});


	//Clic numero telephone footer
	$("footer .contact-and-partners a.tel").off('click');
	$("footer .contact-and-partners a.tel").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic numero telephone footer | clicID = telephone footer") : '';
		dataLayer.push({
			'event': 'Clic numero telephone footer',
			'clicID': 'telephone footer'
		});
	});


	//Clic RS - LinkedIn - Footer
	$("footer .rs .linkedin a").off('click');
	$("footer .rs .linkedin a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic RS - LinkedIn - Footer | clicID = Linkedin footer") : '';
		dataLayer.push({
			'event': 'Clic RS - LinkedIn - Footer',
			'clicID': 'Linkedin footer'
		});
	});


	//Clic RS - LinkedIn - Header
	$("header .rs .linkedin a").off('click');
	$("header .rs .linkedin a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic RS - LinkedIn - Header | clicID = Linkedin Header") : '';
		dataLayer.push({
			'event': 'Clic RS - LinkedIn - Header',
			'clicID': 'Linkedin Header'
		});
	});


	//Clic RS - YouTube - Footer
	$("footer .rs .youtube a").off('click');
	$("footer .rs .youtube a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic RS - Youtube - Footer | clicID = Youtube footer") : '';
		dataLayer.push({
			'event': 'Clic RS - Youtube - Footer',
			'clicID': 'Youtube footer'
		});
	});


	//Clic RS - YouTube - Header
	$("header .rs .youtube a").off('click');
	$("header .rs .youtube a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Clic RS - Youtube - Header | clicID = Youtube header") : '';
		dataLayer.push({
			'event': 'Clic RS - Youtube - Header',
			'clicID': 'Youtube header'
		});
	});


	// MENU PRINCIPAL //
	const gtm_events_menu_principal = new Map([
		['Menu P - Collage',						'#principal-navbar .navbar-right > li:nth-child(1) > a'],
		['Menu P - Colles Resines Silicones',		'#principal-navbar .navbar_secondary ul > li:nth-child(1) > a'],
		['Menu P - Consommables et accessoires',	'#principal-navbar .navbar_secondary ul > li:nth-child(7) > a'],
		['Menu P - Dosage',  						'#principal-navbar .navbar-right > li:nth-child(2) > a'],
		['Menu P - Lampes UV',  					'#principal-navbar .navbar_secondary ul > li:nth-child(6) > a'],
		['Menu P - Le Laboratoire',			  		'#principal-navbar .navbar-right > li:nth-child(5) > a'],
		['Menu P - Nos actualites',  				'#principal-navbar .navbar-right > li:nth-child(4) > a'],
		['Menu P - Nos realisations',  				'#principal-navbar .navbar-right > li:nth-child(3) > a'],
		['Menu P - Robot de dosage',  				'#principal-navbar .navbar_secondary ul > li:nth-child(5) > a'],
		['Menu P - Sur-mesure',  					'#principal-navbar .navbar_secondary ul > li:nth-child(8) > a'],
		['Menu P - Systemes de dosage',  			'#principal-navbar .navbar_secondary ul > li:nth-child(2) > a'],
		['Menu P - Systemes de vidange',  			'#principal-navbar .navbar_secondary ul > li:nth-child(3) > a'],
		['Menu P - Traitement de surface',  		'#principal-navbar .navbar_secondary ul > li:nth-child(4) > a'],
	]);

	gtm_events_menu_principal.forEach((value, key)=> {
		$(value).data("gtm-key", key);
		$(value).off('click');
		$(value).on('click', (e) => {
			debugGTMevents ? console.log('GTM event = ', $(e.currentTarget).data("gtm-key"), " | clicID = Menu principal") : '';
			dataLayer.push({
				'event': $(e.currentTarget).data("gtm-key"),
				'clicID': "Menu principal"
			});
		});
	});


	// MENU SECONDAIRE
	//TODO: à modifier : voir ce qu'on fait pour les dropdown du menu top..."savoir faire / expertise"
	const gtm_events_menu_secondaire = new Map([
		['Menu S - Colles techniques', 			'#principal-navbar .navbar_secondary ul > li:nth-child(1) > ul > li:nth-child(1) > a'],
		['Menu S - Colles universelles', 		'#principal-navbar .navbar_secondary ul > li:nth-child(1) > ul > li:nth-child(2) > a'],
		// ['Menu S - Expertises', 				'#principal-navbar .navbar_secondary ul > li:nth-child(1) > ul > li:nth-child(2) > a'],
		['Menu S - Four UV', 					'#principal-navbar .navbar_secondary ul > li:nth-child(6) > ul > li:nth-child(2) > a'],
		['Menu S - Lampes UV', 					'#principal-navbar .navbar_secondary ul > li:nth-child(6) > ul > li:nth-child(1) > a'],
		['Menu S - Pistolets de dosage', 		'#principal-navbar .navbar_secondary ul > li:nth-child(3) > ul > li:nth-child(2) > a'],
		['Menu S - Pompes volumetriques bi', 	'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(2) > a'],
		['Menu S - Pompes volumetriques mono', 	'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(1) > a'],
		['Menu S - Pousse cartouches', 			'#principal-navbar .navbar_secondary ul > li:nth-child(3) > ul > li:nth-child(4) > a'],
		['Menu S - Reservoirs', 				'#principal-navbar .navbar_secondary ul > li:nth-child(3) > ul > li:nth-child(3) > a'],
		['Menu S - Robots 3 et 4 axes', 		'#principal-navbar .navbar_secondary ul > li:nth-child(5) > ul > li:nth-child(1) > a'],
		['Menu S - Robots sur-mesure', 			'#principal-navbar .navbar_secondary ul > li:nth-child(5) > ul > li:nth-child(2) > a'],
		// ['Menu S - Savoir-faire', 				'#principal-navbar .navbar_secondary ul > li:nth-child(1) > ul > li:nth-child(2) > a'],
		['Menu S - Silicones', 					'#principal-navbar .navbar_secondary ul > li:nth-child(1) > ul > li:nth-child(3) > a'],
		['Menu S - Spray volumetrique', 		'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(3) > a'],
		['Menu S - Système de micro-dosage', 	'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(5) > a'],
		['Menu S - Traitement plasma', 			'#principal-navbar .navbar_secondary ul > li:nth-child(4) > ul > li:nth-child(1) > a'],
		['Menu S - Valves jetting', 			'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(6) > a'],
		['Menu S - Valves de dosage', 			'#principal-navbar .navbar_secondary ul > li:nth-child(2) > ul > li:nth-child(4) > a'],
		['Menu S - Vide futs', 					'#principal-navbar .navbar_secondary ul > li:nth-child(3) > ul > li:nth-child(1) > a'],
	]);

	gtm_events_menu_secondaire.forEach((value, key)=> {
		$(value).data("gtm-key", key);
		$(value).off('click');
		$(value).on('click', (e) => {
			debugGTMevents ? console.log('GTM event = ', $(e.currentTarget).data("gtm-key"), " | clicID = Menu secondaire") : '';
			dataLayer.push({
				'event': $(e.currentTarget).data("gtm-key"),
				'clicID': "Menu secondaire"
			});
		});
	});


	// DOWNLOADS
	$(".nav-utils .dl-fiches li:nth-child(1) a").off('click');
	$(".nav-utils .dl-fiches li:nth-child(1) a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Telechargement catalogue dosage | clicID = Telechargement catalogue dosage") : '';
		dataLayer.push({
			'event': 'Telechargement catalogue dosage',
			'clicID': 'Telechargement catalogue dosage'
		});
	});
	$(".nav-utils .dl-fiches li:nth-child(2) a").off('click');
	$(".nav-utils .dl-fiches li:nth-child(2) a").on('click', (e) => {
		debugGTMevents ? console.log("GTM event = Telechargement catalogue consommables | clicID = Telechargement catalogue consommables") : '';
		dataLayer.push({
			'event': 'Telechargement catalogue consommables',
			'clicID': 'Telechargement catalogue consommables'
		});
	});
}

export const gtmEventsOnPageChange = () => {

	// console.log('gtmEventsOnPageChange')

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'event': 'virtualPageview',
		'page_title': (document.title) ? document.title : '',
		'page_URL': (window.location.href) ?  window.location.href : '',
		'page_path': (window.location.pathname) ? window.location.pathname : '',
		'page_hash': (window.location.hash) ? window.location.hash : '',
	});

	// GENERIC EVENT on .gtm-item elements
	$(".gtm-item").each( function( index ) {
		$(this).off('click');
		$(this).on('click', (e) => {
			debugGTMevents ? console.log("GTM event = ", $(e.currentTarget).data("gtm-event"), " | ", $(e.currentTarget).data("gtm-key"), " = ", $(e.currentTarget).data("gtm-value")) : '';
			dataLayer.push({
				'event': $(e.currentTarget).data("gtm-event"),
				[$(e.currentTarget).data("gtm-key")]: $(e.currentTarget).data("gtm-value")
			});
		})
	});
}